import { Component } from '@angular/core';
import { MediaReplayService } from './core/utils/media-replay.service';
import * as moment from 'moment';

import { AuthGuard } from './core/auth/auth.guard';

@Component({
  selector: 'vr-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  //noinspection JSUnusedLocalSymbols
  constructor(
    public authGuard: AuthGuard,
    mediaReplay: MediaReplayService // workaround for Flex-Layout to receive the initial value
  ) {
    // Nothing here.
    // You probably want to go to /core/layout/ :)
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/app.component.ts